import { useRouter } from 'next/router'
import { useEffect, useState } from 'react'
import { useTranslation } from 'src/utils/i18n'

const NoData = () => {
  const { t, locale } = useTranslation('common')
  const [text, setText] = useState('')
  const [text2, setText2] = useState('')
  const [href, setHref] = useState('')
  const [hrefText, setHrefText] = useState('')
  const router = useRouter()

  useEffect(() => {
    const path = window.location.pathname
    if (path.indexOf('android') != -1) {
      if (path.indexOf('android/local') != -1) {
        setText(t('If there is no data for only some of the features please go to the'))
        setText2(
          t(
            'page to check Also the app cant track social media data before connection so please be patient if the app is fully authorized'
          )
        )
        setHrefText(t('Permission check'))
        setHref(`${process.env.NEXT_PUBLIC_MY_URL}/android/local/permission-check`)
        console.log('安卓apk')
      } else {
        setText(t('Please enable Google backup See'))
        setText2(t('for details'))
        setHrefText(t('here'))

        // if (locale && locale != 'en') {
        //   setHref(
        //     '/guide/back-up-android' + '-' + (locale == 'it-ch' ? 'it' : locale)
        //   )
        // } else {
        //   setHref('/guide/back-up-android')
        // }
      }
    } else {
      setText(t('Please enable iCloud backup See'))
      setText2(t('for details'))
      setHrefText(t('here'))

      // if (locale && locale != 'en') {
      //   setHref('/guide/back-up-ios' + '-' + (locale == 'it-ch' ? 'it' : locale))
      // } else {
      //   setHref('/guide/back-up-ios')
      // }
    }
  }, [locale, t])

  return (
    <>
      {/* {text}{' '}
      <a className='text-[#007AFF]' href={href} target='_blank' rel='noreferrer'>
        {hrefText}
      </a>{' '}
      {text2} */}
      <div className='!h-[calc(var(--vh2)*100-240px)] smj:!h-[calc(var(--vh2)*100-115px)] w-full mt-5 [box-shadow:0px_0px_12px_0px_#00000021] rounded-[10px] bg-white flex justify-center items-center'>
        <div className='text-center px-2'>
          {t('It appears theres no data to show here yet')}<br />
          {t('If data exists it may take up to 1 hour to download and appear')}<br />
          {t('We suggest checking back in a little while')}
        </div>
      </div>
    </>
  )
}

export default NoData